<template>
  <el-row
    type="flex"
    justify="center"
    :class="`er-single-day-picker ${disabled ? 'is-disabled' : ''}`"
  >
    <i class="el-icon-arrow-left" @click="prevDayClick"></i>
    <el-date-picker
      :value="value"
      :size="size"
      :clearable="clearable"
      :picker-options="computedPickerOptions"
      :format="format"
      :value-format="valueFormat"
      :disabled="disabled"
      @input="handleChangeInSelectedDate"
      @change="handleChangeInSelectedDate"
    ></el-date-picker>
    <i class="el-icon-arrow-right" @click="nextDayClick"></i>
  </el-row>
</template>
<script>
import {
  DATE_OBJ_DATE_FORMAT_WITH_YEAR,
  MOMENT_DATE_FORMAT_WITH_YEAR
} from "@/utils/commonUtils";
export default {
  props: {
    clearable: {
      default: false
    },
    size: {
      default: "mini"
    },
    pickerOptions: {
      default: () => ({})
    },
    value: {
      default: ""
    },
    format: {
      default: DATE_OBJ_DATE_FORMAT_WITH_YEAR
    },
    valueFormat: {
      required: true,
      default: "yyyy-MM-dd"
    },
    disabled: {
      default: false
    }
  },
  data: function() {
    return {
      datePickerValue: this.value,
      dateObjToMomentFormat: {
        "yyyy-MM-dd": "YYYY-MM-DD",
        "yyyy-MM-dd HH:mm": "YYYY-MM-DD HH:mm"
      }
    };
  },
  computed: {
    computedPickerOptions: function() {
      return Object.keys(this.pickerOptions).length > 0
        ? this.pickerOptions
        : {
            disabledDate(time) {
              return time.getTime() > Date.now();
            }
          };
    },
    momentFormat() {
      return this.dateObjToMomentFormat[this.valueFormat];
    },
    computedValue: {
      get() {
        return this.$moment(this.value, this.momentFormat).toDate();
      },
      set(value) {
        this.$emit("change-day", value);
      }
    }
  },
  methods: {
    prevDayClick() {
      const value = this.$moment(this.value, this.momentFormat)
        .subtract(1, "days")
        .format(this.momentFormat);
      this.datePickerValue = value;
      this.$emit("change-prev-day", value);
    },
    nextDayClick() {
      const nextDay = this.$moment(this.value, this.momentFormat).add(
        1,
        "days"
      );
      if (nextDay.isSameOrBefore(this.$moment(), "days")) {
        const value = nextDay.format(this.momentFormat);
        this.datePickerValue = value;
        this.$emit("change-next-day", value);
      }
    },
    handleChangeInSelectedDate(value) {
      this.datePickerValue = value;
      this.$emit("change-day", value);
    },
    handleDatePickerInput(value) {
      this.datePickerValue = value;
      this.$emit("change-day", value);
    }
  }
};
</script>

<style lang="scss">
@mixin input-font-size {
  @include responsiveProperty(
    font-size,
    $app_font_size_small,
    $app_font_size_1,
    $app_font_size_2
  );
}
.er-single-day-picker {
  align-items: center;
  justify-items: center;
  @include responsiveProperty(width, 100px, 115px, 140px);
  &.is-disabled {
    .el-input__inner {
      background-color: transparent;
    }
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
  .el-icon-arrow-left,
  .el-icon-arrow-right {
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    @include input-font-size;
    font-weight: 700;
  }
  .el-input__icon {
    line-height: 28px;
    width: 16px;
    @include input-font-size;
  }
  .el-input__inner {
    border: unset;
    text-align: center;
    padding-right: 0px;
    @include input-font-size;
  }
  .el-input__prefix {
    left: 0px;
  }
  .el-input--prefix {
    .el-input__inner {
      padding-left: 16px;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
